import { Button, Icon } from '@platform/components';
import { ROUTES } from '../../routes/consts';

export const BackToMyProjectsButton = () => {
  return (
    <Button
      variant='link-color'
      size='lg'
      additionalClassnames='w-fit'
      href={`/dashboard${ROUTES.MY_PROJECTS}`}
    >
      <Icon type='arrow-left' />
      My Projects
    </Button>
  );
};
